import React, { useState } from "react";

// core components
import { withRouter } from "react-router";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import config from "config.js";
import { Link } from "react-router-dom";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";
import loadContent from "core-module/hoc/loadContent";

import Button from "common/components/CustomButtons/Button.jsx";
import Payment from "@material-ui/icons/Payment";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

const styles = {
  cardIconTitle: importedStyle.cardIconTitle,
  text: {
    margin: 20,
    textAlign: "center",
    alignSelf: "center",
  },
  buttonStyle: {
    margin: "20px",
  },
  highlight: {
    color: "green",
  },
};

const EFTPage = (props) => {
  const [buttonDisable, setButtonDisabled] = useState(false);
  const { classes } = props;

  let pendingphotos;
  props.getList(
    (oGet, id) => {
      pendingphotos = oGet("pendingphotos");
    },
    () => {
      return null;
    }
  );

  function handleAddEFT() {
    setButtonDisabled(true);
    props.goToAddEFT();
  }
  return (
    <div>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Payment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>EFT/PAD</h4>
            </CardHeader>
            <CardBody>
              <GridContainer align="center" justify="center">
                {pendingphotos > 0 ? (
                  <GridItem key="pendingphotostext" xs={12}>
                    <p className={classes.text}>
                      The photo(s) you submited will be processed by our staff.
                      Please check again later.
                    </p>
                  </GridItem>
                ) : (
                  <GridItem key="pendingphotostext2" xs={12}>
                    <p className={classes.text}>There is no pending review.</p>
                  </GridItem>
                )}
                {pendingphotos >= 2 ? (
                  <GridItem key="addphto" xs={12}>
                    <Link to={config.MYACCOUNT.APP_PATH}>
                      <Button
                        className={classes.buttonStyle}
                        color="primary"
                        disabled={false}
                      >
                        Go back to to Main Screen
                      </Button>
                    </Link>
                  </GridItem>
                ) : (
                  <GridItem key="addphto" xs={12}>
                    <p className={classes.text}>
                      When a new payment method is added to your account it
                      becomes your default payment method. You can contact us at
                      any time to remove old payment information.
                    </p>
                    <p className={classes.text}>
                      If contacting us by email, please do <strong>not</strong>{" "}
                      include credit card numbers or confidential information.
                    </p>
                    <Button
                      className={classes.buttonStyle}
                      color="default"
                      disabled={buttonDisable}
                      onClick={props.backToMainScreen}
                    >
                      Back
                    </Button>{" "}
                    <Button
                      className={classes.buttonStyle}
                      color="primary"
                      disabled={buttonDisable}
                      onClick={handleAddEFT}
                    >
                      Upload void cheque
                    </Button>{" "}
                  </GridItem>
                )}
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default withStyles(styles)(
  withRouter(loadContent("user.session/eftphoto", EFTPage))
);
